export const getters = {
  latestExpertResponses: state => state.latestExpertResponses.data,
  latestExpertResponsesPagination: state => state.latestExpertResponses.pagination,
  latestExpertResponsesLoading: state => state.latestExpertResponses.loading,
  latestExpertResponsesError: state => state.latestExpertResponses.error,
  latestClientContacts: state => state.latestClientContacts.data,
  latestClientContactsPagination: state => state.latestClientContacts.pagination,
  latestClientContactsLoading: state => state.latestClientContacts.loading,
  latestClientContactsError: state => state.latestClientContacts.error,
  staffTargets: state => state.staffTargets.data,
  staffTargetsLoading: state => state.staffTargets.loading,
  staffTargetsError: state => state.staffTargets.error,
  teamTargets: state => state.teamTargets.data,
  teamTargetsLoading: state => state.teamTargets.loading,
  teamTargetsError: state => state.teamTargets.error
}
